import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';

import { usePostCheckEmailAvailability } from '../../../hooks';
import { VpHookFormInput } from '../../inputs';
import { EMAIL_REGEX } from '../../../utils/validations';

const NAME = 'email';

const getIsValidEmail = (email) => EMAIL_REGEX.test(email);

export const CompanyEmailInput = ({ defaultValue }) => {
  const [hasError, setHasError] = useState(false);
  const [changeLoading, setChangeLoading] = useState(false);
  const { setError, clearErrors, formState } = useFormContext();

  const removeErrors = () => {
    setHasError(false);
    clearErrors(NAME);
  };

  const onError = () => {
    setHasError(true);
    setError(NAME, { type: 'custom', message: 'Email already exists' });
  };

  const onSuccess = () => {
    removeErrors();
  };

  const { mutate: checkAvailability, isLoading } = usePostCheckEmailAvailability({
    onError,
    onSuccess
  });

  const onChange = ({ target }) => {
    const isValidEmail = getIsValidEmail(target?.value);
    // start loading indicator only if the email is valid
    setChangeLoading(isValidEmail);
  };

  const onChangeDebounce = async ({ target }) => {
    // clear onChange loading after debounce function is called
    setChangeLoading(false);
    // if it's not a valid email, don't check availability
    const isValidEmail = getIsValidEmail(target?.value);
    if (isValidEmail) {
      const data = {
        username: target?.value
      };
      return checkAvailability({ data });
    }

    // clears email availability error if form hasn't been validated
    if (!formState?.isSubmitted) {
      removeErrors();
    }
  };

  const rules = {
    validate: {
      available: () => (hasError ? 'Email already exists' : true)
    }
  };

  return (
    <VpHookFormInput
      defaultValue={defaultValue}
      disabled={!!defaultValue}
      onChange={onChange}
      onChangeDebounce={onChangeDebounce}
      onChangeDebounceTimeout={500}
      maxLength={50}
      required
      isEmail
      name={NAME}
      placeholder="Work Email"
      isLoading={isLoading || changeLoading}
      rules={rules}
    />
  );
};

CompanyEmailInput.propTypes = {
  defaultValue: PropTypes.string
};

export default CompanyEmailInput;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/sign-up/CompanyEmailInput.jsx